.ao{flex-shrink:0;}